// libs
import React, { SyntheticEvent, useCallback, useRef, useState } from 'react'
// interfaces / constants
// components
import InputField, { InputFieldHandle } from 'src/components/forms/input_field/input_field'
// helpers
import { textResources } from 'src/lang/de'

interface IProps {
  onSubmit: (val: string) => void;
  defaultValue?: string;
  onFocus?: (event: SyntheticEvent<HTMLInputElement>, callback: () => void) => void;
}

const SearchField: React.FC<IProps> = ({ onSubmit, defaultValue, onFocus }) => {
  const inputRef = useRef<InputFieldHandle>(null)
  const [value, setValue] = useState(defaultValue || '')

  const onChange = useCallback((val) => {
    setValue(val)
  }, [setValue])

  const handleOnFocus = useCallback((e: SyntheticEvent<HTMLInputElement>) => {
    if (onFocus) {
      onFocus(e, () => {
        inputRef.current && inputRef.current.blurInput()
      })
    }
  }, [onFocus])

  const onFormSubmit = useCallback((e: SyntheticEvent) => {
    e.preventDefault()

    onSubmit(value)
    inputRef.current && inputRef.current.blurInput()
  }, [onSubmit, value])

  const onRightIconClick = useCallback((e: SyntheticEvent) => {
    // to prevent the input of getting refocused after icon click
    e.stopPropagation()
    setValue('')
    onSubmit('')
  }, [setValue, onSubmit])

  return (
    <form onSubmit={onFormSubmit}>
      <InputField
        value={value}
        type={'search'}
        name={'search'}
        placeholder={textResources.profileSearch.searchAndDiscover}
        floatLabel={false}
        iconRight={value ? 'x-circle' : 'search'}
        onChange={onChange}
        onRightIconClick={onRightIconClick}
        ref={inputRef}
        iconSize={22}
        onFocus={handleOnFocus}
      />
    </form>
  )
}

SearchField.displayName = 'SearchField'

export default SearchField
